// extracted by mini-css-extract-plugin
export default {"upload-file__box":"styles_upload-file__box__YuYD5","upload-file__box--disabled":"styles_upload-file__box--disabled__16aqI"};